import {useDispatch} from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import {Alert, Button, Form, Input} from 'antd';

import useAuth from "../../shared/hooks/useAuth";

import {login} from "../../redux/auth/auth-operations";

import styles from "./login-page.module.scss";

const LoginPage = () => {
    const {isLogin, loading, error} = useAuth();
    const dispatch = useDispatch();
    const location = useLocation();

    const onFinish = (values) => {
        dispatch(login(values));
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const fromPage = location.state?.from || "/dashboard";

    if(isLogin) {
        return <Navigate to={fromPage} />
    }

    return (
        <div className={styles.wrapper}>
            <Form
                name="basic"
                labelCol={{
                    xs: {span: 24},
                    sm: {span: 8},
                }}
                wrapperCol={{
                    xs: {span: 24},
                    sm: {span: 16},
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                {error && (
                    <Alert
                        className={styles.error}
                        message={error}
                        type="error"
                        showIcon
                    />
                )}

                <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                        {
                            required: true,
                            message: 'Please input email!',
                        },
                    ]}
                >
                    <Input/>
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your password!',
                        },
                    ]}
                >
                    <Input.Password/>
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        xs: {span: 24, offset: 0},
                        sm: {span: 16, offset: 8},
                    }}
                >
                    <Button className={styles.submit} type="primary" htmlType="submit" loading={loading} disabled={loading}>
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </div>
    )
}

export default LoginPage;
